import { render, staticRenderFns } from "./ExtraworkListDetails.vue?vue&type=template&id=33cebce2&scoped=true&"
import script from "./ExtraworkListDetails.vue?vue&type=script&lang=ts&"
export * from "./ExtraworkListDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraworkListDetails.vue?vue&type=style&index=0&id=33cebce2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cebce2",
  null
  
)

export default component.exports